/**
 * Pill « En vedette » sur les cartes grille (collection / search / dynamique).
 *
 * Source de vérité : window.LovenSponsoredHandles (max 5, tirage aléatoire) + window.LovenSponsored (ids).
 * Alimentée par collection-top-ads.js → événement « loven:sponsored-ready ».
 *
 * Règles :
 *  - On peint UNIQUEMENT la grille visible (statique en mode catalogue, dynamique en mode dispo).
 *  - Handles comparés en lowercase, ids stringifiés.
 *  - Re-peinture sur tous les events qui re-rendent la grille.
 */
(function () {
  'use strict';

  var PILL_HTML =
    '<span class="loven-spons-pill" data-loven-spons role="note" aria-label="Logement en vedette">' +
    '<span class="loven-spons-pill__star" aria-hidden="true">★</span> En vedette</span>';

  function normHandle(h) {
    return String(h || '')
      .toLowerCase()
      .trim();
  }

  /**
   * Grille visible déterministe :
   *  - Mode dynamique actif (`#CollectionAjaxResult.loven-dynamic-availability-mode`)
   *    ET `#loven-dynamic-availability` non hidden ET contient des cartes → c'est elle.
   *  - Sinon : `.loven-static-collection-grid`.
   *  - Sinon (fallback) : `#CollectionAjaxResult`.
   */
  function getVisibleGridRoot() {
    var ajax = document.getElementById('CollectionAjaxResult');
    var staticWrap = document.querySelector('.loven-static-collection-grid');
    var dyn = document.getElementById('loven-dynamic-availability');
    if (
      ajax &&
      ajax.classList.contains('loven-dynamic-availability-mode') &&
      dyn &&
      !dyn.hasAttribute('hidden')
    ) {
      var dynCards = dyn.querySelectorAll('.grid-product[data-product-id]');
      if (dynCards.length) return dyn;
    }
    if (staticWrap) return staticWrap;
    return ajax || document.body;
  }

  /** Overlay en bas à gauche de l'image (jamais dans .grid-product__tags). */
  function findPillHost(card) {
    var wrap = card.querySelector('.grid-product__image-wrap');
    if (!wrap) return null;
    var host = wrap.querySelector('.loven-spons-pill-host');
    if (host) return host;
    host = document.createElement('div');
    host.className = 'loven-spons-pill-host';
    wrap.insertBefore(host, wrap.firstChild);
    return host;
  }

  function buildSets(detail) {
    var idSet = new Set();
    var handleSet = new Set();
    var rawIds =
      detail && detail.ids
        ? detail.ids
        : window.LovenSponsored instanceof Set
          ? Array.from(window.LovenSponsored)
          : [];
    var rawHandles =
      detail && detail.handles
        ? detail.handles
        : window.LovenSponsoredHandles instanceof Set
          ? Array.from(window.LovenSponsoredHandles)
          : [];
    rawIds.forEach(function (id) {
      if (id != null) idSet.add(String(id));
    });
    rawHandles.forEach(function (h) {
      var k = normHandle(h);
      if (k) handleSet.add(k);
    });
    return { ids: idSet, handles: handleSet };
  }

  function paint(detail) {
    var sets = buildSets(detail);
    var root = getVisibleGridRoot();
    var cards = Array.prototype.slice.call(root.querySelectorAll('.grid-product[data-product-id]'));

    var painted = 0;
    var removed = 0;

    cards.forEach(function (card) {
      var hk = normHandle(card.getAttribute('data-product-handle'));
      var pid = String(card.getAttribute('data-product-id') || '');
      var sponsored = (hk && sets.handles.has(hk)) || (pid && sets.ids.has(pid));
      var existing = card.querySelector('[data-loven-spons]');
      if (sponsored) {
        if (existing) return;
        var host = findPillHost(card);
        if (host) {
          host.insertAdjacentHTML('afterbegin', PILL_HTML);
          painted++;
        }
      } else if (existing) {
        existing.remove();
        removed++;
      }
    });

    if (sets.handles.size === 0 && sets.ids.size === 0) return;

    if (painted > 0 || removed > 0) {
      console.info(
        '[Loven sponsored] Pills — posées:' +
          painted +
          ' retirées:' +
          removed +
          ' (cartes scannées: ' +
          cards.length +
          ', éligibles attendus: ' +
          sets.handles.size +
          ')'
      );
    } else if (sets.handles.size > 0) {
      var missing = [];
      var present = {};
      cards.forEach(function (c) {
        var k = normHandle(c.getAttribute('data-product-handle'));
        if (k) present[k] = true;
      });
      sets.handles.forEach(function (h) {
        if (!present[h]) missing.push(h);
      });
      if (missing.length) {
        console.warn(
          '[Loven sponsored] Pills 0 posée — handles éligibles absents du DOM:',
          missing,
          '(cartes présentes: ' + cards.length + ')'
        );
      }
    }
  }

  window.LovenPaintSponsoredBadges = paint;

  function runAfterGridPaint() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        paint();
      });
    });
  }

  document.addEventListener('loven:sponsored-ready', function (e) {
    paint(e.detail);
  });
  document.addEventListener('collection:mapSync', runAfterGridPaint);
  document.addEventListener('collection:mapViewportFiltered', runAfterGridPaint);
  document.addEventListener('collection:availability', runAfterGridPaint);
  document.addEventListener('collection:reloaded', runAfterGridPaint);
  document.addEventListener('collection:destFiltered', runAfterGridPaint);
  document.addEventListener('loven:dynamic-grid-rendered', runAfterGridPaint);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      paint();
    });
  } else {
    paint();
  }
})();
